export default "__VITE_ASSET__FMMkDxpx__"